import React from 'react';
import { BaseState } from '../classes/shared/base.state';
import { IComboBoxOption } from "@fluentui/react";

export default class IoipBaseComponent<T, U extends BaseState<any>> extends React.Component<T, U> {

  protected _changeModelTextField(property: string, value: string | number) {
    this.setState({
      model: {
        ...(this.state.model as any),
        [ property ]: value
      }
    });
  }

  protected _changeModelComboBox(property: string, value?: IComboBoxOption): void {
    if (value) {
      this.setState({
        model: {
          ...(this.state.model as any),
          [ property ]: value.key
        }
      });

    } else {
      this.setState({
        model: {
          ...(this.state.model as any)
        }
      });
    }
  }

  protected _changeModelCheckBox(property: string, ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean): void {
    this.setState({
      model: {
        ...(this.state.model as any),
        [ property ]: checked
      }
    });
  }

  protected _onChangeModelDate(property: string, date: Date | null | undefined): void {
    this.setState({
      model: {
        ...(this.state.model as any),
        [ property ]: date
      }
    });
  };

}
